<script setup>
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const formatHours = hours => {
  if (!hours) return '-';
  if (hours < 1) return `${Math.round(hours * 60)}m`;
  if (hours < 24) return `${hours.toFixed(1)}h`;
  return `${(hours / 24).toFixed(1)}d`;
};
</script>

<template>
  <div
    class="p-4 rounded-xl bg-n-solid-2 shadow outline-1 outline outline-n-container"
  >
    <h3 class="text-base font-medium text-n-slate-12 mb-4">
      {{ $t('CAPTAIN_ANALYTICS.PENDING.TITLE') }}
    </h3>

    <div v-if="isLoading" class="flex items-center justify-center py-8">
      <Spinner />
    </div>

    <div v-else class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-4">
      <div class="flex flex-col items-center p-3 rounded-lg bg-n-amber-3">
        <span class="text-2xl font-bold text-n-amber-11">
          {{ data.pending_by_agent || 0 }}
        </span>
        <span class="text-xs text-n-amber-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.BY_AGENT') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-blue-3">
        <span class="text-2xl font-bold text-n-blue-11">
          {{ data.pending_by_customer || 0 }}
        </span>
        <span class="text-xs text-n-blue-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.BY_CUSTOMER') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-green-3">
        <span class="text-2xl font-bold text-n-green-11">
          {{ data.resolved || 0 }}
        </span>
        <span class="text-xs text-n-green-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.RESOLVED') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-ruby-3">
        <span class="text-2xl font-bold text-n-ruby-11">
          {{ data.long_pending_by_agent || 0 }}
        </span>
        <span class="text-xs text-n-ruby-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.LONG_AGENT') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-purple-3">
        <span class="text-2xl font-bold text-n-purple-11">
          {{ data.long_pending_by_customer || 0 }}
        </span>
        <span class="text-xs text-n-purple-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.LONG_CUSTOMER') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-alpha-3">
        <span class="text-2xl font-bold text-n-slate-12">
          {{ formatHours(data.avg_hours_pending_agent) }}
        </span>
        <span class="text-xs text-n-slate-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.AVG_AGENT') }}
        </span>
      </div>

      <div class="flex flex-col items-center p-3 rounded-lg bg-n-alpha-3">
        <span class="text-2xl font-bold text-n-slate-12">
          {{ formatHours(data.avg_hours_pending_customer) }}
        </span>
        <span class="text-xs text-n-slate-11 text-center">
          {{ $t('CAPTAIN_ANALYTICS.PENDING.AVG_CUSTOMER') }}
        </span>
      </div>
    </div>
  </div>
</template>
